"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIsolateTouch = void 0;

var _react = require("react");

/* eslint-disable react-hooks/exhaustive-deps */
const eventParams = {
  passive: true
};

const useIsolateTouch = () => {
  const [element] = (0, _react.useState)( /*#__PURE__*/(0, _react.createRef)());

  const isolateTouch = event => {
    event.stopPropagation();
  };

  (0, _react.useEffect)(() => {
    const node = element.current;
    node.addEventListener('touchstart', isolateTouch, eventParams);
    node.addEventListener('touchmove', isolateTouch, eventParams);
    node.addEventListener('touchend', isolateTouch, eventParams);
    return () => {
      node.removeEventListener('touchstart', isolateTouch, eventParams);
      node.removeEventListener('touchmove', isolateTouch, eventParams);
      node.removeEventListener('touchend', isolateTouch, eventParams);
    };
  }, []);
  return element;
};

exports.useIsolateTouch = useIsolateTouch;